// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import CreateAlertOrderParametrsSelectorTemplate from '@front/templates/CreateAlertOrderParametrsSelectorTemplate.html';
import { ContainerControl } from '../../elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class CreateAlertOrderParametrsSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'CreateAlertOrderParametrsSelector';
    }
    oninit() {
        super.oninit();
        this.observe('infoBtnTooltip', this.updateInfoText);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    updateInfoText(newValue) {
        void this.set({ enabled: !!newValue });
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    localize() {
        void this.set({
            buttonText: Resources.getResource('panel.orderEntry'),
            label: Resources.getResource('screen.Alerts.Label.OrderParameters'),
            btnTooltip: Resources.getResource('screen.Alerts.Label.OrderParameters.Tooltip')
        });
    }
}
ContainerControl.extendWith(CreateAlertOrderParametrsSelector, {
    template: CreateAlertOrderParametrsSelectorTemplate,
    data: function () {
        return {
            label: '',
            buttonText: '',
            btnTooltip: '',
            instrument: null,
            items: null,
            selectedItem: null,
            enabled: false,
            panelLink: null,
            infoBtnTooltip: '',
            width: 177
        };
    }
});
